import { render, staticRenderFns } from "./BasicBreadcrumb.vue?vue&type=template&id=2581b86c&scoped=true"
import script from "./BasicBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BasicBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./BasicBreadcrumb.vue?vue&type=style&index=0&id=2581b86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581b86c",
  null
  
)

export default component.exports